import { useState } from 'react';

const useRateCalcBottomSheet = () => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  const onClickOpenBottomSheet = () => {
    setIsBottomSheetOpen(true);
  };

  const onClickCloseBottomSheet = () => {
    setIsBottomSheetOpen(false);
  };

  return {
    isBottomSheetOpen,
    setIsBottomSheetOpen,
    onClickOpenBottomSheet,
    onClickCloseBottomSheet,
  };
};

export default useRateCalcBottomSheet;
